import { createFileRoute, redirect } from '@tanstack/react-router';
import { ModifyUserTypePage } from '../components/profile/settings/ModifyUserTypePage';

export const Route = createFileRoute('/profile/settings/user-type')({
  beforeLoad: ({ location }) => {
    if (!localStorage.getItem('access_token')) {
      throw redirect({ to: '/sign-in', search: { redirect: location.pathname } });
    }
  },
  component: ModifyUserTypePage,
});
